import { useState } from "react"
import "./Works.scss"

export default function Works() {

  // Slider state
  const [currentSlide,setCurrentSlide] = useState(0)

  // Skills list
  const worksData = [
    {
      id: 1,
      icon: "/assets/icons/web.png",
      title: "Web Development",
      desc: "Responsive Web Design using: HTML5/CSS3 → SASS, JavaScript → React.js | Databases: PostgreSQL | IDE: VS Code",
      img: "/assets/unsplash/daniel-korpai-pKRNxEguRgM-unsplash.jpg",
    },
    {
      id: 2,
      icon: "/assets/icons/design.png",
      title: "UX Design",
      desc: "Proficient in doing UX Research, User/Human-Centric Design, Wireframing & Prototyping using Figma and Adobe Creative Suites.",
      img: "/assets/unsplash/daniel-korpai-mxPiMiz7KCo-unsplash.jpg",
      url: ""
    },
    {
      id: 3,
      icon: "/assets/icons/mobile.png",
      title: "Mobile Development",
      desc: "Experienced in android mobile development using Android Studio.",
      img: "/assets/unsplash/patrik-michalicka-cv4bk-aedJE-unsplash.jpg",
    },

  ]

  // Arrow click function
  const handleClick = (direction) => {
    direction === "prev" ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : worksData.length - 1 )
    : setCurrentSlide(currentSlide < worksData.length - 1 ? currentSlide + 1 : 0 )
  }

  return (
    <div className="works" id="works">
        <div className="slider" 
            style={{transform:`translateX(-${currentSlide * 100}vw)`}}>

          {worksData.map(d => (
          <div className="container">
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  <div className="imgContainer">
                    <img src={d.icon} alt="" />
                  </div>
                  <h2>{d.title}</h2>
                    <p>{d.desc}</p>
                    <span>
                      {/* <a href={d.url}>Projects</a> */}
                      </span>
                </div>
              </div>
              <div className="right">
                <img 
                  src={d.img} 
                  alt={d.title} />
              </div>
            </div>
          </div>
          ))}
        </div>
        
      <img src="/assets/icons/arrow.svg" className="arrow left" alt="left arrow" onClick={() => handleClick("prev")}/>      
      <img src="/assets/icons/arrow.svg" className="arrow right" alt="right arrow" onClick={() => handleClick("next")}/>

    </div>
  )
}
